import React from 'react';

const Logo = ({ size = 40, className = '' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 40 40" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Rocket body */}
      <path 
        d="M20 8L22 32L18 32L20 8Z" 
        fill="#274768"
      />
      
      {/* Rocket fins */}
      <path 
        d="M16 28L12 32L16 36L20 32L16 28Z" 
        fill="#348AA7"
      />
      <path 
        d="M24 28L28 32L24 36L20 32L24 28Z" 
        fill="#348AA7"
      />
      
      {/* Rocket nose cone */}
      <path 
        d="M20 8L16 12L20 16L24 12L20 8Z" 
        fill="#08D3A0"
      />
      
      {/* Exhaust flames */}
      <path 
        d="M18 32L16 36L20 38L24 36L22 32L18 32Z" 
        fill="#FD745E"
      />
      
      {/* Rocket window */}
      <circle cx="20" cy="18" r="1.5" fill="#348AA7" stroke="#274768" strokeWidth="0.5" />
      
      {/* Trajectory path */}
      <path 
        d="M20 8C20 8 18 10 16 14C14 18 12 24 12 30" 
        stroke="#274768" 
        strokeWidth="2" 
        strokeLinecap="round"
        opacity="0.8"
      />
      
      {/* Destination dot */}
      <circle cx="12" cy="30" r="2" fill="#08D3A0" />
      
      {/* Stars */}
      <circle cx="8" cy="12" r="0.8" fill="#08D3A0" opacity="0.8" />
      <circle cx="32" cy="8" r="0.6" fill="#348AA7" opacity="0.6" />
      <circle cx="6" cy="28" r="0.5" fill="#FD745E" opacity="0.7" />
      <circle cx="34" cy="24" r="0.7" fill="#08D3A0" opacity="0.5" />
    </svg>
  );
};

export default Logo;
